document.addEventListener("DOMContentLoaded", function() {
  // セクションのペアを定義
  const sectionPairs = {
    "search-page": ["search-page", "search-page-featured"],
    "search-product": ["search-product", "search-product-featured"],
    "search-article": ["search-article", "search-article-featured"]
  };

  function displaySections() {
    // 現在のハッシュを取得（# を除去）
    const hash = window.location.hash.substring(1);

    // 全てのセクションを非表示にする
    Object.values(sectionPairs).flat().forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        element.style.display = "none";
      }
    });

    // ハッシュに対応するセクションを表示する
    if (sectionPairs[hash]) {
      sectionPairs[hash].forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.style.display = "block";
        }
      });
    }
  }

  // 初回表示
  displaySections();

  // ハッシュ変更時の処理
  window.addEventListener("hashchange", displaySections);
});
